/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import { AutoComplete, Form } from 'rsuite';
import { FormFieldSize } from 'components/Form/CustomForm/CustomForm';
import FormControlLabel from '../../../Control/FormControlLabel';
// eslint-disable-next-line import/no-unresolved
import styles from './AutoCompleteFormField.module.scss';

interface ITextFormField {
  required: boolean;
  formValue: any;
  onChange: (val: any) => void;
  data: any[];
  size: FormFieldSize;
  disabled?: boolean;
  name: string; // name of the key to map to
  label: string; // field label
  type: 'text' | 'email' | 'number' | 'password';
  helpMessage?: string; // help message to display
  placeholder?: string; // field placeholder
  checkAsync?: boolean; // true if we need to perform async checks on form field
  className?: any; // custom class name for form field group
}

/**
 * Renders text from field
 */
const AutoCompleteFormField = forwardRef(
  (props: ITextFormField, ref: any) => {
    const {
      name,
      size,
      formValue,
      onChange,
      helpMessage = undefined,
      label,
      required,
      data,
      className = undefined,
    } = props;

    return (
      <Form.Group
        ref={ref}
        className={[
          styles.formGroup,
          size === 'sm' ? styles.sm : styles.lg,
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <FormControlLabel required={required || false}>
          {label}{' '}
        </FormControlLabel>
        <div className={styles.controlWrapper}>
          <AutoComplete
            value={formValue[name]}
            onChange={onChange}
            data={data}
            className={styles.autoComplete}
          />
          {helpMessage ? (
            <Form.HelpText>{helpMessage}</Form.HelpText>
          ) : null}
        </div>
      </Form.Group>
    );
  },
);

export default AutoCompleteFormField;
